import { PipeTransform, Pipe } from '@angular/core';

@Pipe({name: 'enumkeys'})
export class EnumKeysPipe implements PipeTransform {

  transform(value, args: string[]): any {
    const keys = [];

    for (const enumMember in value) {
      if (!isNaN(parseInt(enumMember, 10))) {
        keys.push({key: parseInt(enumMember, 10), value: value[enumMember]});
        // Uncomment if you want log
        // console.log('enum member: ', value[enumMember]);
      }
    }

    // console.log(keys);
    return keys;
  }
}



// WEBPACK FOOTER //
// ./client/app/shared/pipes/enum-keys.pipe.ts